import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NAVIGATION_GRID_AREAS, NAVIGATION_VIEWPORT_BREAKPOINTS } from '../../../constants';
import { NavigationItemContainer } from '../../NavigationItem';
import { NavigationItemsContainer } from '../../NavigationItems/styles/navigation-items.styled';
import { NavigationLinkContainer } from '../../NavigationLink';
export const navigationSecondaryContainerStyles = ({ theme, $navigationIsOpen, $hasActiveItem, $hasActiveAction, }) => css `
	position: relative;
	grid-area: ${NAVIGATION_GRID_AREAS.SECONDARY};
	align-self: end;
	display: none;
	gap: ${pxToRem(theme.spacing['50'])};
	margin: 0 -${pxToRem(theme.spacing['300'])};
	flex-direction: column;
	background-color: ${theme.colors.extralight.bgSubNavigation};

	${$navigationIsOpen &&
    !$hasActiveItem &&
    css `
		display: flex;
	`}

	${!$hasActiveAction &&
    css `
		/* to have focus outline on top of navigation main. Not when action is active to not be on top of overlay */
		z-index: ${Number(theme.zIndex.menu) + 1};
	`}

	${NavigationItemsContainer} {
		padding: ${pxToRem(theme.spacing['400'])};
		gap: ${pxToRem(theme.spacing['300'])};
	}
	${NavigationItemContainer} {
		display: inline;
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.md)}) {
		> ${NavigationItemsContainer} {
			padding: ${pxToRem(theme.spacing['400'])} ${pxToRem(theme.spacing['100'])};
		}
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.lg)}) {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		margin: 0;

		> ${NavigationItemsContainer} {
			flex-direction: row;
			gap: ${pxToRem(theme.spacing['400'])};
			margin: 0;
			padding: 0 ${pxToRem(theme.spacing['400'])};

			${NavigationLinkContainer} {
				padding: ${pxToRem(theme.spacing['100'])} 0;
			}
		}
	}

	@media (min-width: ${pxToRem(NAVIGATION_VIEWPORT_BREAKPOINTS.xxl)}) {
		&::before,
		&::after {
			content: '';
			position: absolute;
			top: 0;
			bottom: 0;
			width: calc(50vw - 50%);
			background-color: ${theme.colors.extralight.bgSubNavigation};
		}

		&::before {
			left: 0;
			transform: translateX(-100%);
		}

		&::after {
			right: 0;
			transform: translateX(100%);
		}
	}
`;
export const NavigationSecondaryContainer = styled.nav `
	${navigationSecondaryContainerStyles}
`;
